import { useCallback, useContext } from 'react';

import NodeManagerContext from './NodeManagerContext';

export const useRegisteredRef = (key) => {
  const { register, unregister } = useContext(NodeManagerContext);

  const callback = useCallback(
    (node) => {
      if (node) {
        register(key, node);
      } else {
        unregister(key);
      }
    },
    [key]
  );

  return callback;
};

export default useRegisteredRef;
